import { useState as o, useEffect as f } from "react";
function l(e) {
  const [i, a] = o(null), [c, t] = o(!1);
  return f(() => {
    async function r() {
      const s = e.knock, u = s.client(), d = `/v1/users/${s.userId}/feeds/${e.feedId}/settings`;
      t(!0);
      const n = await u.makeRequest({
        method: "GET",
        url: d
      });
      n.error || a(n.body), t(!1);
    }
    r();
  }, []), {
    settings: i,
    loading: c
  };
}
export {
  l as default
};
//# sourceMappingURL=useFeedSettings.mjs.map
